import { abortable } from './abortable';

/**
 * Convert an async iterable to an array.
 * Alternative to a proposed `Array.fromAsync` API.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/fromAsync
 */
export async function fromAsync<T>(
  iterable: AsyncIterable<T, undefined, AbortSignal | undefined>,
  signal?: AbortSignal,
): Promise<T[]> {
  const items: T[] = [];

  for await (const item of abortable(iterable, { signal })) {
    items.push(item);
  }

  return items;
}
